export default "__VITE_ASSET__7360b3d3__"